import { graphql } from 'gatsby';

export { default } from './Profile';

export const pageQuery = graphql`
  query ProfileQuery($id: String) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        name
        pronouns
        role
        photo {
          id
          childImageSharp {
            desktop: fixed(cropFocus: CENTER, width: 300, height: 300) {
              ...GatsbyImageSharpFixed_noBase64
            }

            desktopSmall: fixed(
              cropFocus: CENTER
              width: 150
              height: 150
            ) {
              ...GatsbyImageSharpFixed_noBase64
            }

            mobile: fixed(cropFocus: CENTER, width: 410, height: 300) {
              ...GatsbyImageSharpFixed_noBase64
            }
          }
        }
      }
    }
  }
`;
